// (c) TwistedMinds, Gerry Uytdenhouwen - 5 november 2026

/**
 * State of the change-password block. Passwords are never trimmed: spaces may be part of them.
 *
 * @param {{current: string, next: string, repeat: string}} values
 * @returns {{complete: boolean, mismatch: boolean}} complete = all three filled in;
 *          mismatch = a repeat was typed that differs from the new password
 */
export const passwordFormState = (values) => {
    const current = values.current || '';
    const next = values.next || '';
    const repeat = values.repeat || '';
    return {
        complete: current !== '' && next !== '' && repeat !== '',
        mismatch: repeat !== '' && next !== repeat,
    };
};
